export const SET_AUTO_APPROVE_PLAINTEXT_PASSWORD =
	"SET_AUTO_APPROVE_PLAINTEXT_PASSWORD";
export const SET_KNOWN_HOSTS = "SET_KNOWN_HOSTS";
export const SET_REMOTE_CONFIG_JSON = "SET_REMOTE_CONFIG_JSON";
export const SET_FINGERPRINT = "SET_FINGERPRINT";
export const SET_USER_USERNAME = "SET_USER_USERNAME";
export const SET_USER_INFO_1 = "SET_USER_INFO_1";
export const SET_USER_INFO_2 = "SET_USER_INFO_2";
export const SET_USER_PASSWORD_SHA1_PREFIX = "SET_USER_PASSWORD_SHA1_PREFIX";
export const SET_USER_INFO_3 = "SET_USER_INFO_3";
export const SET_REQUIRE_PASSWORD_CHANGE = "SET_REQUIRE_PASSWORD_CHANGE";
export const SET_HASHING_PARAMETERS = "SET_HASHING_PARAMETERS";
export const SET_SERVER_SECRET_EXISTS = "SET_SERVER_SECRET_EXISTS";
export const SET_HAS_TWO_FACTOR = "SET_HAS_TWO_FACTOR";
export const SET_EMAIL = "SET_EMAIL";
export const SET_USER_DATASTORE_OVERVIEW = "SET_USER_DATASTORE_OVERVIEW";
export const LOGOUT = "LOGOUT";
export const SET_SERVER_STATUS = "SET_SERVER_STATUS";
export const SET_SERVER_URL = "SET_SERVER_URL";
export const SET_SERVER_INFO = "SET_SERVER_INFO";
export const SET_SERVER_POLICY = "SET_SERVER_POLICY";
export const SET_CLIENT_URL = "SET_CLIENT_URL";
export const ENABLE_OFFLINE_MODE = "ENABLE_OFFLINE_MODE";
export const DISABLE_OFFLINE_MODE = "DISABLE_OFFLINE_MODE";
export const SET_OFFLINE_CACHE_ENCRYPTION_INFO =
	"SET_OFFLINE_CACHE_ENCRYPTION_INFO";
export const SET_NOTIFICATION_ON_COPY = "SET_NOTIFICATION_ON_COPY";
export const SET_DISABLE_BROWSER_PM = "SET_DISABLE_BROWSER_PM";
export const SET_SHOW_FILTERS = "SET_SHOW_FILTERS";
export const SET_HIDE_DOWNLOAD_BANNER = "SET_HIDE_DOWNLOAD_BANNER";
export const SET_LAST_POPUP_SEARCH = "SET_LAST_POPUP_SEARCH";
export const SETTINGS_DATASTORE_LOADED = "SETTINGS_DATASTORE_LOADED";
export const SET_PASSWORD_CONFIG = "SET_PASSWORD_CONFIG";
export const SET_PASSPHRASE_CONFIG = "SET_PASSPHRASE_CONFIG";
export const SET_DEFAULT_PASSWORD_GENERATOR = "SET_DEFAULT_PASSWORD_GENERATOR";
export const SET_SHOWN_ENTRIES_CONFIG = "SET_SHOWN_ENTRIES_CONFIG";
export const SET_GPG_CONFIG = "SET_GPG_CONFIG";
export const SET_GPG_DEFAULT_KEY = "SET_GPG_DEFAULT_KEY";
export const NOTIFICATION_SEND = "NOTIFICATION_SEND";
export const NOTIFICATION_SET = "NOTIFICATION_SET";
export const SET_REQUESTS_IN_PROGRESS = "SET_REQUESTS_IN_PROGRESS";
export const SET_CLIENT_CONFIG = "SET_CLIENT_CONFIG";
export const SET_DOMAIN_SYNONYMS_CONFIG = "SET_DOMAIN_SYNONYMS_CONFIG";
export const SET_CONNECTION_AUTHENTICATION = "SET_CONNECTION_AUTHENTICATION";
export const SET_GATEWAY_CLUSTER_SELECTION = "SET_GATEWAY_CLUSTER_SELECTION";
export const SET_DEVICE_CODE = "SET_DEVICE_CODE";
export const CLEAR_DEVICE_CODE = "CLEAR_DEVICE_CODE";
